import { ValidationSchema } from '../../core';
import useFastFormProviderContext from './useFastFormProviderContext';

function useFormValidationSchema(): ValidationSchema<any> {
  const context = useFastFormProviderContext();
  return context.validationSchema;
}

export default useFormValidationSchema;
